import React from 'react';
import { Box, Content, Strong, CheckIcon, AlertIcon, TagAlready } from './styled';
import { IProps } from './types';

export const Feedback: React.FC<IProps> = ({ error, timerFinished }) => {
  if (timerFinished) {
    return (
      <TagAlready>
        <CheckIcon />
        Oba! Você já pode enviar sua pergunta :)
      </TagAlready>
    );
  }
  if (!error || !error.status) {
    return null;
  }

  return (
    <Box hasTitle={!!error?.title}>
      <AlertIcon hastitle={!!error?.title} />
      <Content hasTitle={!!error?.title}>
        <Strong>{error.title}</Strong>
        {error?.message}
      </Content>
    </Box>
  );
};
